import { _TEST1234 } from "../features/config/ApiConfig";

export const DATE_LOCALE = { ko: "ko_KR", en: "en_US", tz: "en_US" };
export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm:ss";
export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_FORMAT_INPUT = { ko: "yyyy-MM-dd", en: "dd/MM/yyyy", tz: "dd/MM/yyyy" };
export const DATE_FORMAT_DAYJS = { ko: "YYYY-MM-DD", en: "DD/MM/YYYY", tz: "DD/MM/YYYY" };
export const TIME_FORMAT_INPUT = { ko: "HH:mm", en: "HH:mm", tz: "HH:mm" };
export const TIME_FORMAT_DAYJS = { ko: "HH:mm", en: "HH:mm", tz: "HH:mm" };
export const DATETIME_FORMAT_INPUT = { ko: "yyyy-MM-dd HH:mm", en: "dd/MM/yyyy HH:mm", tz: "dd/MM/yyyy HH:mm" };
export const DATETIME_FORMAT_DAYJS = { ko: "YYYY-MM-DD HH:mm", en: "DD/MM/YYYY HH:mm", tz: "DD/MM/YYYY HH:mm" };
export const DATETIMESECOND_FORMAT_DAYJS = {
    ko: "YYYY-MM-DD HH:mm:ss",
    en: "DD/MM/YYYY HH:mm:ss",
    tz: "DD/MM/YYYY HH:mm:ss",
};
export const APRV_URL = "http://localhost:3700/ptli/comnmdle/aprv/ptli0409006s";

export const COMN_CODE_API =
    _TEST1234.SYSTEM_GROUP_ENV === "tanoga"
        ? process.env.REACT_APP_API_PTL_COMN + `/api/v1/osci/ptl/comnppup`
        : _TEST1234.PORTAL_API_ORI + `/api/v1${_TEST1234.SYSTEM === "internal" ? "/osci/ptl/" : "/osci/ptl/"}comnppup`;
export const COMN_CODE: any = {
    cityCd: {
        value: "regnCd",
        label: "regnNm",
        path: "",
        path_async: "/regn/city-cd-list",
        async: true,
        asyncLength: 3,
    },
    unLocCd: {
        value: "regnCd",
        label: "regnNm",
        path: "",
        path_async: "/regn/city-cd-list?regnTpCd=02",
        async: true,
        asyncLength: 3,
    },
    portCd: {
        value: "regnCd",
        label: "regnNm",
        path: "",
        path_async: "/regn/port-cd-list",
        async: true,
        asyncLength: 3,
    },
    portAirptCd: {
        value: "regnCd",
        label: "regnNm",
        path: "",
        path_async: "/regn/port-airpt-cd-list",
        async: true,
        asyncLength: 3,
    },
    airptCd: {
        value: "regnCd",
        label: "regnNm",
        path: "",
        path_async: "/regn/airpt-cd-list",
        async: true,
        asyncLength: 3,
    },
    vhclMdlCd: {
        value: "vhclMdlCd",
        label: "vhclMdlNm",
        path: "",
        path_async: "/vhcl/mdl-list",
        async: true,
        asyncLength: 1,
    },
    vhclMdlNoCd: {
        value: "vhclMdlNoCd",
        label: "vhclMdlNoNm",
        path: "",
        path_async: "/vhcl/mdl-no-list",
        async: true,
        asyncLength: 1,
    },
    coUsr: {
        value: "usrId",
        label: "usrNm",
        path: "",
        path_async: "/co-usr-list",
        async: true,
        asyncLength: 1,
    },
    comnCd: {
        value: "cdVldVal",
        label: "cdVldValNm",
        path: "",
    },
    cntyCd: {
        value: "cntyCd",
        label: "cntyNm",
        path: "",
    },
    dgt3CntyCd: {
        value: "dgt3CntyCd",
        label: "cntyNm",
        path: "",
    },
    dgt3NumCntyCd: {
        value: "dgt3NumCntyCd",
        label: "cntyNm",
        path: "",
    },
    currCd: {
        value: "currCd",
        label: "currNm",
        path: "",
    },
    bnkCd: {
        value: "cdVldVal",
        label: "cdVldValNm",
        path: "",
    },
    prcssStatCd: {
        value: "item",
        label: "itemNm",
        path: "",
    },
    orgCd: {
        value: "orgCd",
        label: "orgNm",
        path: "",
    },
    orgAbrt: {
        value: "orgCd",
        label: "orgAbrtNm",
        path: "",
    },
    wrhsCd: {
        value: "coDclaCd",
        label: "wrhsNm",
        path: "",
    },
    carrCd: {
        value: "coDclaCd",
        label: "carrNm",
        path: "",
    },
    coDclaCd: {
        value: "coCd",
        label: "coNm",
        path: "",
    },
    orgDeptCd: {
        value: "deptCd",
        label: "deptNm",
        path: "",
    },
    cstmCd: {
        value: "cstmOfceCd",
        label: "cstmNm",
        path: "",
    },
    cstmOfcrCd: {
        value: "usrDmnId",
        label: "usrNm",
        path: "",
    },
    vhclBodyCd: {
        value: "vhclBodyTpCd",
        label: "vhclBodyTpNm",
        path: "",
    },
    vhclCtgrCd: {
        value: "vhclCtgrCd",
        label: "vhclCtgrNm",
        path: "",
    },
    vhclClrCd: {
        value: "vhclClrCd",
        label: "vhclClrNm",
        path: "",
    },
    vhclFlCd: {
        value: "vhclFlTpCd",
        label: "vhclFlNm",
        path: "",
    },
    vhclMkerCd: {
        value: "vhclMkerCd",
        label: "vhclMkerNm",
        path: "",
    },
    vhclImpCntyCd: {
        value: "vhclCntyCd",
        label: "vhclCntyNm",
        path: "",
    },
    vhclInsrTpCd: {
        value: "vhclInsrTpCd",
        label: "vhclInsrTpNm",
        path: "",
    },

    vhclHlpnCtgrCd: {
        value: "vhclHlpnCtgrCd",
        label: "vhclHlpnCtgrNm",
        path: "",
    },
    vhclPrplTpCd: {
        value: "vhclPrplTpCd",
        label: "vhclPrplTpNm",
        path: "",
    },
    vhclTrmssnTpCd: {
        value: "vhclTrmssnTpCd",
        label: "vhclTrmssnTpNm",
        path: "",
    },
    vhclUseCd: {
        value: "vhclUseCd",
        label: "vhclUseNm",
        path: "",
    },
    cgmePrcdCd: {
        value: "comnCdVal",
        label: "comnCdLbl",
        path: "",
    },
    cgmiPrcdCd: {
        value: "comnCdVal",
        label: "comnCdLbl",
        path: "",
    },
    cgmeLstCd: {
        value: "comnCdVal",
        label: "comnCdLbl",
        path: "",
    },
    cgmiLstCd: {
        value: "comnCdVal",
        label: "comnCdLbl",
        path: "",
    },
    hsCd: {
        value: "hsCd",
        label: "hsDesc",
        path: "",
    },
    hsCdPopup: {
        value: "hsCd",
        label: "hsDesc",
        path: "",
    },
    postCd: {
        value: "wardPostCd",
        label: ["wardPostNm", "dstrPostNm", "regnPostNm"],
        path: "",
    },
    trmnlOptrCd: {
        value: "trmnlOptrCd",
        label: "trmnlOptrNm",
        path: "",
    },
    tb: {
        value: "tbId",
        label: "tbNm",
        path: "",
    },
    indvCdTb: {
        value: "tbId",
        label: "tbNm",
        path: "",
    },
    col: {
        value: "colId",
        label: "colNm",
        path: "",
    },
    indvCdCol: {
        value: "colId",
        label: "colNm",
        path: "",
    },
    lbl: {
        value: "lblId",
        label: "lblNm",
        path: "",
    },
    comnCdMstr: {
        value: "comnCd",
        label: "comnCdNm",
        path: "",
    },
    dclt: {
        value: "dcltTin",
        label: "dcltNm",
        path: "",
    },
    orgUsr: {
        value: "usrId",
        label: "usrNm",
        path: "",
    },
    coBucn: {
        value: "bucnTin",
        label: "bucnNm",
        path: "",
    },
    ectePrcdCd: {
        value: "comnCdVal",
        label: "comnCdLbl",
        path: "",
    },
    ectiPrcdCd: {
        value: "comnCdVal",
        label: "comnCdLbl",
        path: "",
    },
    hldy: {
        value: "ctraDt",
        label: "hldyNm",
        path: "",
    },
    csldrTin: {
        value: "csldrTin",
        label: "csldrNm",
        path: "",
    },
    roleCd: {
        value: "roleId",
        label: "roleNm",
        path: "",
    },
    dclrPrcdCd: {
        value: "comnCdVal",
        label: "comnCdLbl",
        path: "",
    },
    profile: {
        value: "idntfNo",
        label: "coNm",
        path: "",
    },
    prflCo: {
        value: "idntfNo",
        label: "coNm",
        path: "",
    },
    prflCsbr: {
        value: "idntfNo",
        label: "coNm",
        path: "",
    },
    prflCsbrCo: {
        value: "idntfNo",
        label: "coNm",
        path: "",
    },
    prflHscd: {
        value: "idntfNo",
        label: "coNm",
        path: "",
    },
};

export default {
    DATE_LOCALE,
    DATE_FORMAT,
    TIME_FORMAT,
    DATETIME_FORMAT,
    DATE_FORMAT_INPUT,
    DATE_FORMAT_DAYJS,
    TIME_FORMAT_INPUT,
    TIME_FORMAT_DAYJS,
    DATETIME_FORMAT_INPUT,
    DATETIME_FORMAT_DAYJS,
    DATETIMESECOND_FORMAT_DAYJS,
    APRV_URL,
};
